import { render } from "./GiftCardsDigitalesNew.vue?vue&type=template&id=6714c707&scoped=true"
import script from "./GiftCardsDigitalesNew.vue?vue&type=script&lang=js"
export * from "./GiftCardsDigitalesNew.vue?vue&type=script&lang=js"

import "./GiftCardsDigitalesNew.vue?vue&type=style&index=0&id=6714c707&lang=css&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6714c707"]])

export default __exports__